interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "確認",
  cancelLabel = "取消",
  danger = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onCancel}
      />
      {/* Modal */}
      <div className="relative bg-white rounded-xl w-full max-w-sm mx-4 shadow-xl">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-3">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${danger ? "bg-red-50" : "bg-amber-50"}`}>
              <i className={`${danger ? "ri-error-warning-line text-red-500" : "ri-question-line text-amber-600"} text-xl`} />
            </div>
            <h3 className="font-display text-base font-bold text-navy-900">{title}</h3>
          </div>
          <p className="font-body text-sm text-navy-500 leading-relaxed ml-[52px]">{message}</p>
        </div>
        <div className="flex items-center justify-end gap-2 px-6 pb-5">
          <button
            onClick={onCancel}
            className="font-body text-sm font-medium px-4 py-2 rounded-lg border border-navy-200 text-navy-600 hover:bg-navy-50 cursor-pointer whitespace-nowrap"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`font-body text-sm font-medium px-4 py-2 rounded-lg text-white cursor-pointer whitespace-nowrap ${danger ? "bg-red-500 hover:bg-red-600" : "bg-navy-700 hover:bg-navy-800"}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}